module.exports = __webpack_public_path__ + "img/C04TechTakabara2.2ac07b23.webp";